export default "__VITE_ASSET__cbf278f9__"